import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CollapsibleUI from '../../../../components/UI/CollapsibleUI';
import { BackButton, Button, Input, Label, Modal, Title } from '../../../../components/UI/ComponentsUI';
import Select from '../../../../components/UI/Select';
import TextAreaUI from '../../../../components/UI/TextAreaUI';
import StockService from '../../../../services/StockService';
import { ENUMS } from '../../../../utils/constants';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { downloadFile, isNullOrEmpty, newObj, showMessageToast, showMessageToastCustom, translate } from '../../../../utils/util';
import FilterJourneyMvm from '../FilterJourneyMvm';
import FormPartNumber from '../Form/FormPartNumber';
import SelectResourceForm from '../Form/SelectResourceForm';

const DeemForm = (props) => {
    const update = props.location?.state?.update;
    const defaultDataForm = {
        mvmNumber: '',
        journey: '',
        invoice: '',
        supplier: '',
        supplierName: '',
        areas: '',
        leader: '',
        inCharge: '',
        shippingCompany: '',
        vehicleType: '',
        plate: '',
        observation: '',
        isCarriedOut: false,
        type: ENUMS.eFormType.Deem.value,
        items: [],
        questions: [],
        printer: undefined
    };

    const [openModalPrintDownload, setOpenModalPrintDownload] = useState(false);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [data, setData] = useState(update && props.deem ? props.deem : null);
    const [receipt, setReceipt] = useState();
    const [dataForm, setDataForm] = useState(update && props.deem ? props.deem : defaultDataForm);
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        if (!isNullOrEmpty(dataForm.invoice) && data) {
            let dataObj = newObj(data);
            dataObj.receipts = dataObj.receipts?.filter((f) => f.invoice === dataForm.invoice);
            dataObj.invoice = dataObj.receipts?.find(x => x.invoice === dataForm.invoice)

            setData({ ...dataObj });
        } else {
            setReceipt();
        }
        // eslint-disable-next-line
    }, [dataForm.invoice]);

    const onChange = (event) => {
        onValueChange(event, dataForm, setDataForm);
    };

    const onChangeReceipt = (event) => {
        onValueChange(event, receipt, setReceipt);
    };

    const onSetData = (data) => {
        setData();
        setReceipt();

        if (data) {
            dataForm.mvmNumber = data.mvmNumber;
            dataForm.journey = data.journey;

            if (!update) {
                dataForm.items = [];
                dataForm.questions = [];
                dataForm.plate = data.plate;
                dataForm.invoice = '';
            }

            setDataForm({ ...dataForm });
            setData(data);

            if (props.deem?.fromReceipt) {
                setPartnumberFromReceipt(props.deem.partNumberCode, data.receipts)
            }

            props.getQuestionsAll({ type: ENUMS.eFormType.Deem.value }, (data) => {
                setQuestions(data);
            })
        }
    }

    const setPartnumberFromReceipt = (event, dataReceipts) => {
        var Receipt = dataReceipts.find((f) => f.partNumberCode === event);
        if (Receipt) {
            setReceipt({ ...Receipt })
        }
    };

    const onChangeSelect = (event) => {
        let item = dataForm.items?.find(x => x.partNumberCode === event);
        if (isNullOrEmpty(item)) {
            var Receipt = data.receipts?.find((f) => f.partNumberCode === event);
            if (Receipt) {
                setReceipt({ ...Receipt })
            }
        } else {
            showMessageToast({ html: `Desenho ${event} já adicionado`, classes: 'red' });
        }
    };

    const onGetArea = () => {
        if (dataForm && dataForm.items) {
            var areas = [];
            dataForm.items.forEach(element => {
                if (!isNullOrEmpty(element.area) && !areas.find(f => f === element.area)) {
                    areas.push(element.area);
                }
            });
            dataForm.areas = areas.join(", ");
            setDataForm({ ...dataForm })
        }
    };

    const addItem = (callback) => {
        if (dataForm && dataForm.items && !dataForm.items.find(f => f.id === receipt.id)) {
            var itemPartNumber = {
                partNumberCode: receipt.partNumberCode,
                partNumberDescription: receipt.partNumberDescription,
                declaredLabelQuantity: parseInt((receipt?.accoutingQuantity || 1) / (receipt.qme || 1) > 0 ? 1 : 0),
                declaredQuantity: receipt.accoutingQuantity,
                receivedLabelQuantity: receipt.volumeReceived,
                receivedQuantity: receipt.amountReceived,
                deem: receipt.deem,
                mdr: receipt.mdr,
                sqpNew: receipt.sqpNew,
                area: receipt.almox
            };
            dataForm.items.push(itemPartNumber);
            setDataForm({ ...dataForm });
            onGetArea();
            setReceipt();
            if (callback) {
                callback();
            }
        } else {
            showMessageToast({ html: `Desenho ${receipt.partNumberCode} já adicionado`, classes: 'red' });
        }
    };

    const removedItem = (item) => {
        if (dataForm && dataForm.items) {
            dataForm.items = dataForm.items.filter(f => f.id !== item.id);
            setDataForm({ ...dataForm });
        }
    };

    const sendForms = () => {
        if (validateInputsRequired("filterInvoiceMvm") && validateInputsRequired("filterConferente")) {
            if (!update) {
                props.addForm(dataForm, (response) => {
                    downloadFile(response.report, `deem${response.form.id}.pdf`, "data:application/pdf", true)
                    reset()
                    redirect();
                })
            } else {
                props.editForm(dataForm, (response) => {
                    downloadFile(response.report, `deem${response.form.id}.pdf`, "data:application/pdf", true)
                    reset()
                    redirect();
                })
            }
        }
    }

    const redirect = () => {
        if (props.deem?.fromReceipt) {
            props.history.push({ pathname: './../../receipt/V2/receiptStorages' })
        }
        else {
            props.history.go(-1);
        }
    }

    const validationSend = () => {
        if (dataForm.items.length > 0 && validateInputsRequired("filterInvoiceMvm") && validateInputsRequired("filterConferente")) {
            setOpenModalPrintDownload(true);
        } else {
            showMessageToastCustom(translate('warning', 'general'), translate('obligatory-fields', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    };

    const reset = () => {
        setDataForm({ ...defaultDataForm });
        setData();
        setReceipt();
    }

    const onChangeSupplier = (supplier) => {
        dataForm.supplierName = supplier.name.trim();
        setDataForm({ ...dataForm });
    };

    const addAnswer = (item, value) => {
        let question = dataForm.questions.find(x => x.questionId === item.id);

        if (question !== undefined) {
            question.answerId = value
        } else {
            dataForm.questions.push({
                questionId: item.id,
                answerId: value,
            });
        }
    };

    const addObservation = (item, value) => {
        let question = dataForm.questions.find(x => x.questionId === item.id);

        if (question !== undefined) {
            question.observation = value
        } else {
            dataForm.questions.push({
                observation: value
            });
        }
    };

    const editPartnumber = (item) => {
        let list = [];
        Object.assign(list, dataForm.items);

        let itemDataForm = list?.find(f => f.partNumberCode === item.partNumberCode);

        itemDataForm.receivedLabelQuantity = item.receivedLabelQuantity
        itemDataForm.receivedQuantity = item.receivedQuantity
        setDataForm({ ...dataForm, items: list });
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('deemsqp:menu.deem-form')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <FilterJourneyMvm callback={onSetData} update={update} type={defaultDataForm.type} />
                {data &&
                    <>
                        <FormPartNumber
                            onChangeSupplier={onChangeSupplier}
                            receipt={receipt}
                            dataForm={dataForm}
                            data={data}
                            onChange={onChange}
                            onChangeSelect={onChangeSelect}
                            onChangePartNumber={onChangeReceipt}
                            addItem={addItem}
                            removedItem={removedItem}
                            deem="true"
                            update={update}
                            closePartnumber={false}
                            editPartnumber={(editedItem) => editPartnumber(editedItem)}
                            filterPartNumber={props.deem && props.deem.fromReceipt ? props.deem?.partNumberCode : ''}
                        />
                        <div className="container" >
                            <CollapsibleUI
                                id="filterQuestions"
                                header={`Itens de Disturbio - Logística Interna`}
                                simple="true"
                                close="true"
                                body={
                                    <>
                                        <div id="formFilterQuestions" className="card-content" style={{ paddingBlockEnd: '1px' }}>
                                            {questions.map((item, index) => {
                                                let ans = dataForm.questions.find(x => x.questionId === item.id)
                                                return (
                                                    <div key={index} style={{ marginTop: '10px' }}>
                                                        <b className="black-text" style={{ marginTop: '10px' }}>
                                                            {index + 1} - {item.description}
                                                        </b>
                                                        <div className="input-field no-padding no-margin-top col s12" style={{ marginLeft: '20px' }}>
                                                            <Select
                                                                required
                                                                id="answer"
                                                                name="answer"
                                                                display="text"
                                                                placeHolder={translate('choose-one-option', 'general')}
                                                                data={questions.find(f => f.id === item.id)?.answers.map((i) => {
                                                                    return { id: i.id, text: i.description };
                                                                })}
                                                                change={(e) => {
                                                                    addAnswer(item, e.target.value);
                                                                }}
                                                                defaultValue={ans?.answerId}
                                                            />
                                                        </div>
                                                        <div className="input-field no-padding col s12" style={{ marginLeft: '20px' }}>
                                                            <Input
                                                                type="text"
                                                                label="Observação"
                                                                id="observationQuestion"
                                                                name='observationQuestion'
                                                                onChange={e => addObservation(item, e.target.value)}
                                                                defaultValue={ans?.observation}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div className="input-field no-padding  col s12">
                                            <TextAreaUI
                                                label="Observações Gerais"
                                                defaultValue={dataForm?.observation || ''}
                                                id="observation"
                                                name="observation"
                                                onChange={onChange}
                                                data-length="300" />

                                        </div>
                                    </>

                                }
                            ></CollapsibleUI>
                        </div>
                        <div className="container" >
                            <CollapsibleUI
                                id="filterConferente"
                                header={`Analise Efetivação Deem`}
                                simple
                                close
                                body={
                                    <div id="formfilterConferente" className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                                        <div className="row">
                                            <div className="input-field no-padding col s12">
                                                <Label
                                                    id="lecturer"
                                                    name="lecturer"
                                                    value={`${props.user?.userName} - ${props.user?.name}`} />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input
                                                    required
                                                    type="text"
                                                    label="Area(s)"
                                                    id="areas"
                                                    name='areas'
                                                    onChange={onChange}
                                                    value={dataForm?.areas || ""}
                                                />
                                            </div>
                                            <div className="input-field no-padding col s12 m6">
                                                <Input
                                                    required
                                                    value={dataForm?.inCharge || ""}
                                                    type="text"
                                                    label="Encarregado"
                                                    id="inCharge"
                                                    name='inCharge'
                                                    onChange={onChange}
                                                />
                                            </div>
                                            <div className="input-field no-padding col s12 m5">
                                                <Input
                                                    required
                                                    value={dataForm?.leader || ""}
                                                    type="text"
                                                    label="Lider"
                                                    id="leader"
                                                    name='leader'
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                            />
                            <div className="row" style={{ paddingTop: '0px' }}>
                                <Button full="true" text="Enviar" onClick={() => {
                                    validationSend();
                                }} />
                            </div>
                        </div>
                    </>
                }
            </div>

            <Modal
                open={openModalPrintDownload}
                maxHeight="45%"
                id="ModalPrintDownload"
                title={`Gerar Relatório DEEM`}
                content={`Informe o Recurso para impressão automatica`}
                children={<SelectResourceForm onChangePrinter={(printer) => {
                    dataForm.printer = printer;
                    setDataForm(dataForm);
                }} />}
                dismissible={false}
                onConfirm={() => { setOpenModalPrintDownload(false); setOpenModalConfirm(true); }}
                onCancel={() => {
                    dataForm.printer = undefined;
                    setDataForm(dataForm);
                    setOpenModalPrintDownload(false)
                }}
                btnConfirm="Gerar"
                btnCancel="Cancelar"
            />
            <Modal
                open={openModalConfirm}
                maxHeight="45%"
                id="ModalConfirm"
                title={`Confirmar geração de relatório?`}
                dismissible={false}
                onConfirm={() => {
                    setOpenModalConfirm(false);
                    sendForms();
                }}
                onCancel={() => {
                    setOpenModalConfirm(false);
                }}
                btnConfirm="Confirmar"
                btnCancel="Cancelar"
            />

        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        deem: state.stockReducer.deem
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addForm: (form, callback) => {
            dispatch(StockService.addFormDeem(form, callback));
        },
        editForm: (form, callback) => {
            dispatch(StockService.editFormDeem(form, callback));
        },
        getQuestionsAll: (filter, callback) => {
            dispatch(StockService.getQuestionsAll(filter, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeemForm)));